import { combatCenterDistanceFt, combatCenterLimitFt, combatVerticalSeparationFt } from '../../../ft3d/engine/ft3d-combat-distance-core.js';

type Point = { x: number; y: number; z: number };

/** Reach reads the compiled total through the page's layer reader, including lean omissions. */
export function creatureReachFt(caster: Record<string, unknown> | null | undefined,
    value: (row: Record<string, unknown>, key: string) => unknown): number | undefined {
    const raw = caster ? value(caster, 'reach') : null;
    const feet = raw == null || raw === '' ? 5 : Number(raw);
    return Number.isFinite(feet) && feet >= 0 ? feet : undefined;
}

/** A placed centre is sizeless. Range and its horizontal clamp use the same persisted combat span;
 * the launch/eye point and rendered body dimensions belong only to sight and line of effect. */
export function placedAoeRange(from: Point, center: Point, casterSizeFt: number | null, rangeFt: number):
    { distanceFt: number; planarLimitFt: number } {
    const vertical = combatVerticalSeparationFt(center.z - from.z, casterSizeFt, 0);
    const limit = combatCenterLimitFt(rangeFt, casterSizeFt, 0);
    return { distanceFt: combatCenterDistanceFt(from, center, { sourceSizeFeet: casterSizeFt, targetSizeFeet: 0 }),
        planarLimitFt: Math.sqrt(Math.max(0, limit * limit - vertical * vertical)) };
}
